import { Component, Input } from '@angular/core';

@Component({
    selector: 'cl-alert-bubble',
    templateUrl: './alert-bubble.component.html',
    styleUrls: ['./alert-bubble.component.scss']
})
export class AlertBubbleComponent {
    public static $name: string = 'clAlertBubble';

    @Input() alertColor: string;
    @Input() alertCount: number;
    @Input() text = '';

    /* Whether or not to still render the bubble when you have no alerts */
    @Input() showZero: boolean;
}
